export const SQL_KEYWORDS = [
  "select",
  "from",
  "where",
  "join",
  "inner",
  "left",
  "right",
  "full",
  "outer",
  "on",
  "group",
  "by",
  "having",
  "order",
  "asc",
  "desc",
  "limit",
  "offset",
  "as",
  "distinct",
  "union",
  "all",
  "and",
  "or",
  "not",
  "in",
  "is",
  "null",
  "between",
  "like",
  "case",
  "when",
  "then",
  "else",
  "count",
  "sum",
  "avg",
  "min",
  "max",
  "end",
];
